module.exports = __webpack_public_path__ + "img/feecodecamp.4bb296e3.webp";